// removed by extract-text-webpack-plugin
module.exports = {"table":"M6ikjgWEsGv4VwimaL0da","loading":"KlqdrRPtxio-bn-vpAMRh"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/CustomersProfiles/Table.module.css
// module id = 2341
// module chunks = 1